import { featureFlagsReducer } from 'li-feature-flags/lib'
import {
  _auth,
  actions,
  reducer,
  alert,
  alertReducer,
  updateUi,
  appShellUiActions,
  appShellUiReducer,
} from './lib'
import { reducer as helpReducer } from './help'
import configure from './configure'
import * as util from './util'
import Login from './components/Login'
import AppLink from './components/Header/AppLink'

import './styles'

const reducers = {
  auth: reducer,
  alert: alertReducer,
  appShellUi: appShellUiReducer,
  help: helpReducer,
  featureFlags: featureFlagsReducer,
}

export {
  _auth,
  actions,
  reducer,
  reducers,
  Login,
  configure,
  util,
  AppLink,
  alert,
  alertReducer,
  updateUi,
  appShellUiActions,
  appShellUiReducer,
  helpReducer,
  featureFlagsReducer,
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/index.js